<template>
    <div class="more-info">
    <div v-if="phone"  class="items">
      <img src="../assets/imgs/10/now.png" @click="call" alt="">
    </div>
    <div v-if="site" class="items">
      <img src="../assets/imgs/10/call.png" @click="now" alt="">
    </div>
    <div v-if="goIndex"  class="items">
      <img src="../assets/imgs/10/go.png" @click="go" alt="">
    </div>
  </div>

</template>

<script>
export default {
    name: '',
    props:['site','phone','goIndex'],
    components: {},
    data(){
        return {

        }
    },
    created(){},
    mounted(){},
    computed: {},
    methods: {
      now(){
        // console.log(this.site);
        if(this.site){
          window.location.href=this.site
        }else{
          this.$toast('暂未开放线上办理，可拨打电话咨询');
        }
      },
      call(){
        window.location.href='tel:'+this.phone
      },
      go(){
        if(this.goIndex==1){
          // 人才驿站
          wx.miniProgram.redirectTo({
                url: `../talentService/talentStage`
            })
        }else{
          // 人才公寓
          wx.miniProgram.redirectTo({
                url: `../talentService/talentService`
            })
        }
      }
    }
}
</script>

<style lang="scss" scoped>

  .more-info {
    z-index: 9999;
    position: fixed;
    right: 50%;
    transform: translateX(53%);
    bottom: 5%;
    display:flex;
    .items{
      width: 2.32rem;
      height: 0.8rem;
      background-color:#006cff;
      display:flex;
      border-radius: 26px;
      margin-right: 0.4rem;
      box-shadow: 1px 1px 3px #006cff, -1px -1px 3px #006cff;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
</style>